const mixin = {
  methods: {
    onLoadEnd () {
      this.$emit('tab-load-end')
    },

    onRequestError () {
      this.$emit('tab-error')
    }
  }
}

export default mixin
